
<div>
  <b-row>
    <FileField
      v-model="file"
      class="col-12"
      :label="__('common.file')"
      name="file"
      required
    />
  </b-row>

  <div class="text-right">
    <b-button variant="primary" size="sm" @click="upload">
      <Icon class="mr-2" icon="upload" size="14" />
      {{ __('buttons.upload') }}
    </b-button>
  </div>
</div>
